module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "payment-form-page"
  }, [(_vm.enableMakingBills) ? _c('div', {
    staticClass: "bar-pos-page-chips section-bottom-sm"
  }, _vm._l((_vm.locations), function(c) {
    return _c('button', {
      key: c,
      staticClass: "bar-pos-page-chips item",
      class: {
        active: _vm.selectedLocation === c
      },
      on: {
        "click": function($event) {
          return _vm.selectLocation(c)
        }
      }
    }, [_vm._v(_vm._s(c) + "\n      ")])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "account--wrapper"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-push-4 col-md-4"
  }, [_c('div', {
    staticClass: "card ui-card form--account payment-form-card"
  }, [_c('H1', [_vm._v(_vm._s(_vm.locale.t("label_add_payment")))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_choose_package')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedPackage),
      expression: "selectedPackage"
    }],
    staticClass: "form-control input",
    attrs: {
      "name": "uloga"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedPackage = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.onSelectedPackage(_vm.selectedPackage)
      }]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("-- izaberi paket --")]), _vm._v(" "), _vm._l((_vm.packages), function(item) {
    return _c('option', {
      domProps: {
        "value": item
      }
    }, [_vm._v("\n                            " + _vm._s(item.name) + "\n                          ")])
  })], 2)])])])]), _vm._v(" "), (_vm.additionalTypes.length > 0) ? _c('div', {
    staticClass: "scrollmenu section-bottom-sm"
  }, [_c('span', {
    staticClass: "form-subtitle"
  }, [_vm._v(_vm._s(_vm.locale.t('label_payment_types')) + ": ")]), _vm._v(" "), _vm._l((_vm.paymentTypes), function(item) {
    return _c('span', [_c('span', {
      staticClass: "chips-group clickable",
      attrs: {
        "value": ""
      },
      on: {
        "click": function($event) {
          _vm.model.additionalService = item.value
        }
      }
    }, [_c('span', {
      staticClass: "single-chip"
    }, [_c('span', {
      class: _vm.getChipTypeClass(item)
    }, [_vm._v(_vm._s(_vm.isSelectedType(item) ? '✔ ' : '') + _vm._s(item.label))])])]), _vm._v(" \n                    ")])
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_payment_date')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.paidDate),
      expression: "model.paidDate"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "date",
      "placeholder": _vm.locale.t('label_payment_date'),
      "name": "uplata"
    },
    domProps: {
      "value": (_vm.model.paidDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "paidDate", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_payment_expire_date')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.expireDate),
      expression: "model.expireDate"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "date",
      "placeholder": _vm.locale.t('label_payment_expire_date'),
      "name": "isticanje"
    },
    domProps: {
      "value": (_vm.model.expireDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "expireDate", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_payment_num_trainings')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(3), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.trainingNumber),
      expression: "model.trainingNumber"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "number",
      "placeholder": _vm.locale.t('label_payment_num_trainings'),
      "name": "treninzi"
    },
    domProps: {
      "value": (_vm.model.trainingNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "trainingNumber", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('h3', {
    staticClass: "text-center payment-form-section-title"
  }, [_vm._v(_vm._s(_vm.locale.t('label_payment_type_trainings')) + " "), _c('i', {
    staticClass: "ti-plus clickable",
    on: {
      "click": function($event) {
        return _vm.openTrainingTypes()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "payment-types"
  }, [_c('ul', {
    staticClass: "checkbox-list"
  }, _vm._l((_vm.filteredTypes), function(key) {
    return _c('li', {
      key: key
    }, [_c('label', {
      attrs: {
        "for": key
      }
    }, [_c('input', {
      attrs: {
        "type": "checkbox",
        "id": key
      },
      domProps: {
        "value": key,
        "checked": _vm.setSelectedCheckBox(key)
      },
      on: {
        "click": function($event) {
          return _vm.onChangeCheckBox(key)
        }
      }
    }), _vm._v("\n                        " + _vm._s(key) + "\n                      ")])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_payment_money')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(4), _vm._v(" "), (_vm.showConcreteValueForPayment) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.paidMoney),
      expression: "model.paidMoney"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "number",
      "placeholder": _vm.locale.t('label_payment_money'),
      "name": "treninzi"
    },
    domProps: {
      "value": (_vm.model.paidMoney)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "paidMoney", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.showConcreteValueForPayment) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.paidMoney),
      expression: "model.paidMoney"
    }],
    staticClass: "form-control input",
    attrs: {
      "name": "uplata"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.model, "paidMoney", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1",
      "selected": ""
    }
  }, [_vm._v("Uplatio")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Duguje")])]) : _vm._e()])])])]), _vm._v(" "), (_vm.selectedDiscount != null && _vm.selectedDiscount > 0) ? _c('div', {
    staticClass: "discount-chips-scope"
  }, [_c('div', {
    staticClass: "row total"
  }, [_c('span', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_amount_with_discount')))]), _vm._v(" "), _c('span', {
    staticClass: "value payment-success-text"
  }, [_c('b', [_vm._v(_vm._s(_vm.formatMoney(_vm.getTotalPriceWithDiscount())))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "discount-chips-scope section-bottom-sm"
  }, [_c('div', {
    staticClass: "cart-title"
  }, [_vm._v(_vm._s(_vm.locale.t('label_discount')))]), _vm._v(" "), _c('div', {
    staticClass: "chips discount-margin"
  }, [_vm._l((_vm.discounts), function(c) {
    return _c('button', {
      key: c,
      staticClass: "chip",
      class: {
        active: Number(_vm.selectedDiscount) === c
      },
      on: {
        "click": function($event) {
          return _vm.selectDiscount(c)
        }
      }
    }, [_vm._v("\n                      " + _vm._s(c) + " %\n                    ")])
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedDiscount),
      expression: "selectedDiscount"
    }],
    staticClass: "chip discount-min-input",
    attrs: {
      "type": "number",
      "placeholder": _vm.locale.t('label_insert_discount'),
      "min": "0",
      "max": "100"
    },
    domProps: {
      "value": (_vm.selectedDiscount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.selectedDiscount = $event.target.value
      }
    }
  })], 2)]), _vm._v(" "), (_vm.showPaymentInvoiceLink) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_payment_link_invoice')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(5), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.invoiceLink),
      expression: "model.invoiceLink"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": _vm.locale.t('label_payment_link_invoice'),
      "name": "treninzi"
    },
    domProps: {
      "value": (_vm.model.invoiceLink)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "invoiceLink", $event.target.value)
      }
    }
  })])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_payment_comment')) + " ")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.comment),
      expression: "model.comment"
    }],
    staticClass: "textarea-full",
    attrs: {
      "rows": "5"
    },
    domProps: {
      "value": (_vm.model.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "comment", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), (_vm.showMemberShipForProgram) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_mp_for_program')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(6), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.forProgram),
      expression: "model.forProgram"
    }],
    staticClass: "ui-checkbox",
    attrs: {
      "type": "checkbox",
      "placeholder": _vm.locale.t('label_mp_for_program'),
      "name": "treninzi"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.forProgram) ? _vm._i(_vm.model.forProgram, null) > -1 : (_vm.model.forProgram)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.forProgram,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "forProgram", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "forProgram", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "forProgram", $$c)
        }
      }
    }
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.addNumberTrainingsWithNewPaymentWithCurrentState) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_add_on_current_state_trainings')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(7), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.addTrainingsWithCurrentState),
      expression: "model.addTrainingsWithCurrentState"
    }],
    staticClass: "ui-checkbox",
    attrs: {
      "type": "checkbox",
      "placeholder": _vm.locale.t('label_add_on_current_state_trainings'),
      "name": "treninzi"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.addTrainingsWithCurrentState) ? _vm._i(_vm.model.addTrainingsWithCurrentState, null) > -1 : (_vm.model.addTrainingsWithCurrentState)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.addTrainingsWithCurrentState,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "addTrainingsWithCurrentState", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "addTrainingsWithCurrentState", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "addTrainingsWithCurrentState", $$c)
        }
      }
    }
  })])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_payment_for_company')) + " ? ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(8), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.isForCompany),
      expression: "model.isForCompany"
    }],
    staticClass: "ui-checkbox",
    attrs: {
      "type": "checkbox",
      "placeholder": _vm.locale.t('label_payment_for_company'),
      "name": "isForCompany"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.isForCompany) ? _vm._i(_vm.model.isForCompany, null) > -1 : (_vm.model.isForCompany)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.isForCompany,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "isForCompany", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "isForCompany", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "isForCompany", $$c)
        }
      }
    }
  })])])])]), _vm._v(" "), _c('h3', {
    staticClass: "text-center payment-form-section-title"
  }, [_vm._v(_vm._s(_vm.locale.t('label_payment_equipment')) + " "), _c('i', {
    staticClass: "ti-plus clickable",
    on: {
      "click": function($event) {
        return _vm.openAdditionalKit()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "payment-types"
  }, [_c('ul', {
    staticClass: "checkbox-list"
  }, _vm._l((_vm.allKits), function(key) {
    return _c('li', {
      key: key
    }, [_c('label', {
      attrs: {
        "for": key
      }
    }, [_c('input', {
      attrs: {
        "type": "checkbox",
        "id": key
      },
      domProps: {
        "value": key,
        "checked": _vm.setSelectedCheckBoxKits(key)
      },
      on: {
        "click": function($event) {
          return _vm.onChangeCheckBoxKits(key)
        }
      }
    }), _vm._v("\n                        " + _vm._s(key) + "\n                      ")])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "payment-paid-with-selector"
  }, [_c('div', {
    staticClass: "cart-title"
  }, [_vm._v(_vm._s(_vm.locale.t('label_paid_with')))]), _vm._v(" "), _c('div', {
    staticClass: "chips"
  }, [_c('button', {
    staticClass: "chip payment-paid-with-button payment-paid-with-button--cash",
    class: {
      active: _vm.model.paidWith == null || _vm.model.paidWith === 'CASH'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.selectPaidWith('CASH')
      }
    }
  }, [_c('i', {
    staticClass: "ti-money"
  }), _vm._v(" " + _vm._s(_vm.locale.t('label_cash')) + "\n                    ")]), _vm._v(" "), _c('button', {
    staticClass: "chip payment-paid-with-button payment-paid-with-button--card",
    class: {
      active: _vm.model.paidWith === 'CARD' || _vm.model.paidWith === 'ONLINE_CARD'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.selectPaidWith('CARD')
      }
    }
  }, [_c('i', {
    staticClass: "ti-credit-card"
  }), _vm._v(" " + _vm._s(_vm.locale.t('label_card')) + "\n                    ")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group text-center"
  }, [_c('div', {
    staticClass: "new-button",
    on: {
      "click": _vm.addPayment
    }
  }, [_c('i', {
    staticClass: "ti-save"
  }), _vm._v(" " + _vm._s(_vm.locale.t("label_save")) + "\n                      ")])])])])], 1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-user"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-plus"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-money"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-link"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-plus"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-package"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e32b9344!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Users/Payment/Add/AddPayment.vue
// module id = 857
// module chunks = 0